import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { Button } from "@/components/ui/button";
import { LeadDialog } from "@/components/LeadDialog";
import { useStats, useContent } from "@/hooks/useData";

export default function About() {
  const { data: stats } = useStats();
  const { content } = useContent();
  const c = content.about_page || {};
  return (
    <div data-testid="about-page">
      <PageHeader eyebrow={c.header_eyebrow} title={c.header_title} accent={c.header_accent} description={c.header_description} />

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal className="img-frame aspect-[4/3]">
            <img src={c.intro_image} alt="Premium interior" className="w-full h-full object-cover" />
          </Reveal>
          <div>
            <h2 className="font-display text-3xl sm:text-4xl font-medium text-[#2C2A29] leading-snug">{c.intro_heading}</h2>
            <p className="text-[#5E5A54] font-light leading-relaxed mt-5 text-lg">{c.intro_paragraph1}</p>
            <p className="text-[#5E5A54] font-light leading-relaxed mt-4 text-lg">{c.intro_paragraph2}</p>
          </div>
        </div>
      </section>

      <section className="bg-[#F6F5F2]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-2 lg:grid-cols-4 gap-8">
          {[
            { v: `${stats?.factory_partners ?? 80}+`, l: "Factory Partners" },
            { v: `${stats?.factories_access ?? 3000}+`, l: "Factories Accessible" },
            { v: `${stats?.projects_completed ?? 120}+`, l: "Projects Completed" },
            { v: "5%", l: "Profit to Charity" },
          ].map((s) => (
            <div key={s.l} className="text-center">
              <div className="font-display text-5xl sm:text-6xl font-medium text-[#2C2A29]">{s.v}</div>
              <div className="label-eyebrow text-[10px] text-[#5E5A54] mt-2">{s.l}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28">
        <SectionHeading eyebrow={c.promise_eyebrow} title={c.promise_title} accent={c.promise_accent} description={c.promise_description} align="center" />
        <div className="text-center mt-10">
          <LeadDialog trigger={<Button className="rounded-none bg-[#2C2A29] hover:bg-[#4A4641] text-[#FFFFFF] h-12 px-8 label-eyebrow text-[10px]" data-testid="about-cta-button">{c.promise_button}</Button>} />
        </div>
      </section>
    </div>
  );
}
